import { Component, OnInit } from '@angular/core';
import { AuthPageManageService } from '../../services/manage/page-manage/auth-page-manage.service';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { ActivatedRoute, Router } from '@angular/router';
import { SmsnotificationsService } from 'src/app/services/apiclient/smsnotifications/smsnotifications.service';
import { userAccountsDomainsService } from 'src/app/services/apiclient/userAccountsDomains/userAccountsDomains.service';
import { environment } from 'src/environments/environment';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css'],
})

export class AuthComponent implements OnInit {

  // Clé sms
  smsNotif: any;

  // Nom de la page où rediriger après authentification
  redirectPage: any;

  // Composant actuel de la partie auth
  currComp$: any;

  // Loader
  loader: boolean = true;
  invalidSmsCode: boolean = false;
  obserCurrentPage: any;

  constructor(
    private authPageServ: AuthPageManageService,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private route: ActivatedRoute,
    private router: Router,
    private smsApi: SmsnotificationsService,
    private userAccountsDomainsService: userAccountsDomainsService,
    private tools: ToolsService
  ) { }

  ngOnInit() {
    this.onInit();
  }

  onInit() {

    // Récupère les parametres d'url
    this.route.params.subscribe((params: any) => {

      // Set la page où rediriger après authentification
      this.redirectPage = params.redirectPage.replace(/\*/g, '/');

      // Si il y a une clé sms en parametre url
      if (params.smsKey) {

        // Google analytics set le nom de la page  à  traquée
        this.angulartics2GoogleAnalytics.pageTrack("auth/registerSms");

        // Récupère la sms notif
        this.smsApi.getSmsNotification(params.smsKey).then(smsKeyData => {

          // Si aucune erreur
          if (smsKeyData.code === 0) {

            // Set la sms notif
            this.smsNotif = smsKeyData.sms_notification;
            this.authPageServ.setSmsNotif(smsKeyData.sms_notification);
          }
          else{
            this.invalidSmsCode = true;
          }

          // Récupère le composant à afficher
          this.getCurrComp();

          // Si une erreur est survenue alors on redirige vers la page d'erreur avec le message d'erreur associé
          /*else {
            this.router.navigate(["/404", smsKeyData.message], { skipLocationChange: true })
          }*/

        });

        // Si il n'y a pas de clé sms en parametre url
      } else {


        // Récupère la sms notification
        this.authPageServ.getSmsKey().subscribe(smsKeyData => {

          if (smsKeyData) {
            this.smsNotif = smsKeyData;
          }

        });


        // Récupère le composant à afficher
        this.getCurrComp();

      }

    });
  }

  /**
     * @description Récupère le domain
      */
  getUserAccountDomain(data?: any) {

    let urlto = !environment.production ? "http://localhost:4200" : 'https://webshop.fulleapps.io';

    this.tools.removeStor("domainUser");
    this.tools.setFavicone(false);

    if (window.location.origin !== urlto) {

      // monespacecommandes.fr
      this.userAccountsDomainsService.getUserAccountDomain(window.location.host).subscribe((domain: any) => {

        if (domain && domain.denomination) {

          let denomination = domain.denomination.replaceAll(' ', '-');
          denomination = denomination.toLowerCase();

          let url = domain.id_point_of_sale && domain.id_webshop ? "/s/" + denomination + "/" + domain.id_webshop + "/" + domain.id_point_of_sale :
            "/p/" + denomination + "/" + domain.id_merchant;
          this.tools.setStor("domainUser", true);
          this.tools.setFavicone(true);
          //redirect


          this.router.navigate([url]);

        }
        else {
          // Set le composant
          this.currComp$ = (data) ? data : "register";


          // Fin du loader
          this.loader = false;
        }






      })
    } else {
      // Set le composant
      this.currComp$ = (data) ? data : "register";


      // Fin du loader
      this.loader = false;
    }

  }

  /**
   * @description Récupère le composant à afficher, et stop le loader
   * @return {void}
   */
  getCurrComp() {

    // Récupère le nom du composant de la partie auth à afficher
    this.obserCurrentPage = this.authPageServ.getCurrPage().subscribe((data) => {


      if (!data && window.location.origin !== 'https://webshop.fulleapps.io') {
        this.getUserAccountDomain(data);

      }
      else {

        // Set le composant
        this.currComp$ = (data) ? data : "register";


        // Fin du loader
        this.loader = false;
      }

    });
  }

  ngOnDestroy(): void {
    if (this.obserCurrentPage) {
      this.obserCurrentPage.unsubscribe();
    }
  }
}
